import { FFmpeg } from '@ffmpeg/ffmpeg';
import { useState, useRef, useEffect, React } from 'react';
import { fetchFile, toBlobURL } from '@ffmpeg/util';
import { addDoc, collection, doc, updateDoc, getDoc, increment } from "firebase/firestore";
import { getStorage, getDownloadURL, ref as storageRef, uploadBytesResumable } from "firebase/storage";
import { db } from '../../../../../../globals/firebase'
import scale from "../../../../../common/scale";
import { w2popup } from 'https://cdn.jsdelivr.net/gh/vitmalina/w2ui@master/dist/w2ui.es6.min.js'
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import SectionJobsPayment from '../section-jobs-payment';
import { LuUpload } from "react-icons/lu";
import { BsJournalRichtext } from "react-icons/bs";
import { Runware } from "@runware/sdk-js";
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';


function SectionJobsSidebar1() {

  const { t, i18n } = useTranslation()
  const ffmpegRef = useRef(new FFmpeg());
  const [currenttime, setcurrenttime] = useState("00:00:00")
  const [videourl, setvideourl] = useState('https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4')
  const [imageurl, setimageurl] = useState('https://images.pexels.com/photos/67216/lions-animal-male-female-lions-67216.jpeg')
  const [texttext, settxttext] = useState('')
  const [privateprompt, setprivatepromp] = useState(false)
  const [loggeduser, setloggeduser] = useState({
    email: "",
    picture: "",
    userid: "",
    name: ""
  })

  const [modalPaymentOpen, setmodalPaymentOpen] = useState(false);

  const ref = player => {
    player = player
  }

  useEffect(() => {
    const fileUploader = document.getElementById('file-uploader');
    let imageUpload = document.getElementById('upload-image-grid');
    if (fileUploader) {
      let i = 0
      fileUploader.addEventListener('change', (event) => {

        if (i === 0) {
          const file = event.target.files[0];
          const imageUrl = URL.createObjectURL(file);
          setimageurl(imageUrl)
          if (imageUpload) {
            imageUpload.src = imageUrl;
          }
          //img.alt = file.name;

        }
      })
    }

    const fileUploaderv = document.getElementById('file-uploaderv');
    let videoUpload = document.getElementById('video-grid');
    if (fileUploaderv) {
      let i = 0
      fileUploaderv.addEventListener('change', (event) => {

        if (i === 0) {
          const file = event.target.files[0];
          const videoUrl = URL.createObjectURL(file);
          setvideourl(videoUrl)
          if (videoUpload) {
            videoUpload.src = videoUrl;
          }
          //img.alt = file.name;

        }

      });

    }

    setloggeduser(JSON.parse(localStorage.getItem("user")))


    if (loggeduser !== null && loggeduser !== undefined) {
      //getuser()
    }

    load()

  }, []); // Or [] if effect doesn't need props or state


  const notify = (type, wait, message) => {
    if (wait === false) {
      let color = ""

      if (type === 'error') {
        w2popup.close()
        color = 'red'
      }

      if (type == 'success') {
        color = 'green'
      }

      if (type === 'message') {
        color = 'gold'
      }

      const titlet = type === "error" ? "Error" : ""
      const title = '<span style="color:' + color + ';font-weight:bold">' + titlet + '</span'
      const messagebody = '<span style="color:' + color + '">' + message + '</span'

      w2popup.open({
        modal: true,
        width: 250,       // width of the popup
        height: 150,       // height of the popup
        color: '#000',
        title: title,
        body: messagebody,
        showClose: true,
        actions: {
          Ok(event) {
            w2popup.close()
          }
        }
      })


    }

    if (wait === true) {
      w2popup.open({
        modal: true,
        width: 250,       // width of the popup
        height: 150,       // height of the popup
        color: '#000',
        text: t("general.pleasewait"),
        showClose: false,

      })


    }
  }

  const closenotify = () => {
    w2popup.close()
  }

  const parabase64 = async (blob) => {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }


  const addpromptimage = async (base64, imageurl) => {

    if (base64 == null || imageurl == null) {
      notify("error", false, t("sidebar.pleasetype") + " image or video")
      return
    }

    try {

      const runware = await Runware.initialize({ apiKey: process.env.REACT_APP_RUNWARE_KEY });
     
      console.log("Runware initialized")
      
      // Remove data URL prefix to send raw base64
      const base64Data = base64.replace(/^data:image\/[a-z]+;base64,/, "");
      console.log("Sending base64 image length:", base64Data.length);

      const imageToText = await runware.caption({
        inputImage: base64Data,
        model: "runware:150@2"
      })

      console.log("Runware response:", JSON.stringify(imageToText))
      const myCollection = collection(db, 'wpm_prompts');

      await addDoc(myCollection, {
        userid: loggeduser.userid,
        username: loggeduser.name,
        imageurl: imageurl,
        prompttitle: "",
        prompttext: imageToText.text,
        public: !privateprompt,
        datainsert: Date.now()
      }).then(async () => {

        await setcredits(-1, "prompts")
        closenotify()

      })


    } catch (e) {
      console.error("Runware error details:", e);
      // closenotify()
      notify("error", false, "error: " + (e.message || e))

    }
  }

  const setchecked = async (inputchecked, type) => {
    const totalcredits = await getusercreditsprompts()

    if (totalcredits < 11) {
      if (type == "text") {
        document.getElementById("CheckCheckedText").checked = false;
      }
      if (type == "image") {
        document.getElementById("CheckCheckedImage").checked = false;
      } if (type == "video") {
        document.getElementById("CheckCheckedVideo").checked = false;

      }
      openpayment()
      return
    }
    setprivatepromp(inputchecked)
  }

  const addprompttext = async () => {

    if (texttext == null || texttext == "") {
      notify("error", false, t("sidebar.pleasetypetext"))
      return
    }

    notify("", true, t("general.pleasewait"))

    try {

      const runware = await Runware.initialize({ apiKey: process.env.REACT_APP_RUNWARE_KEY });

      const newprompt = await runware.enhancePrompt(
        {
          "taskType": "promptEnhance",
          "taskUUID": "9da1a4ad-c3de-4470-905d-5be5c042f98a",
          "prompt": texttext,
          "promptMaxLength": 64,
          "promptVersions": 1
        })


      const myCollection = collection(db, 'wpm_prompts');
      await addDoc(myCollection, {
        userid: loggeduser.userid,
        username: loggeduser.name,
        imageurl: "",
        prompttitle: texttext,
        prompttext: newprompt[0].text,
        public: !privateprompt,
        datainsert: Date.now()
      }).then(async () => {
        await setcredits(-1, "prompts")
      })

    } catch (e) {
      notify("error", false, "error: " + e)
    }
    finally {
      closenotify()
    }
  }

  const handleSeekChange = e => {
    setcurrenttime(toTimeString(e.target.currentTime))
    //console.log(toTimeString(e.target.currentTime))
  }

  const toTimeString = seconds => {
    return (new Date(seconds * 1000)).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0];
  }

  const changevideotext = (e) => {
    //console.log(e.target.value)
    setvideourl(e.target.value)
  }

  const changeimagetext = (e) => {
    // console.log(e.target.value)

    let imageUpload = document.getElementById('upload-image-grid');
    imageUpload.src = e.target.value
    setimageurl(e.target.value)
  }


  const changetxttext = (e) => {
    settxttext(e.target.value)
  }

  const handlePause = e => {
    setcurrenttime(toTimeString(e.target.currentTime))
  }
  const handleReady = e => {
    document.querySelector('video').addEventListener('resize', (e) => {

    });
  }

  const getusercreditsprompts = async () => {

    const userData = localStorage.getItem("user");
    if (!userData) {
      console.warn("User not found in localStorage");
      return 0;
    }
    
    const user = JSON.parse(userData);
    if (!user.userid) {
      console.warn("User ID not found in user data");
      return 0;
    }

    const userid = user.userid;

    const docRef = doc(db, "wpm_users", userid)
    const userdoc = await getDoc(docRef);
    
    if (userdoc.exists()) {
      const data = userdoc.data();
      console.log("Credits check for user " + userid + ":", data);
      return data.creditsprompts != null ? Number(data.creditsprompts) : 0;
    }
    return 0;

  }

  const openpayment = () => {
    setmodalPaymentOpen(true)
  }

  const setcredits = async (credits, type) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"))

      if (!user || !user.userid) {
        console.error("User not found for setcredits");
        return;
      }

      const docRef = doc(db, "wpm_users", user.userid)
      
      console.log(`Attempting to update credits for ${type}: ${credits}`);

      // Using increment for atomic updates
      if (type === "prompts") {
        await updateDoc(docRef, {
          creditsprompts: increment(credits)
        });
      }

      if (type === "images") {
        await updateDoc(docRef, {
          creditsimages: increment(credits)
        });
      }
      console.log(`Credits updated successfully for ${type}`);

    } catch (error) {
      console.error("Error in setcredits:", error);
      notify("error", false, "Error updating credits: " + error.message);
    }
  }


  const load = async () => {
    const baseURL = 'https://unpkg.com/@ffmpeg/core@0.12.6/dist/umd'
    const ffmpeg = ffmpegRef.current;
    ffmpeg.on('log', ({ message }) => {
      //messageRef.current.innerHTML = message;
      //console.log(message);
    });
    // toBlobURL is used to bypass CORS issue, urls with the same
    // domain can be used directly.
    await ffmpeg.load({
      coreURL: await toBlobURL(`${baseURL}/ffmpeg-core.js`, 'text/javascript'),
      wasmURL: await toBlobURL(`${baseURL}/ffmpeg-core.wasm`, 'application/wasm'),
    });
    // setLoaded(true);

    // console.log(loaded)
  }


  const transcodevideo = async () => {

    const totalcredits = await getusercreditsprompts()
    console.log("Transcode video - Total credits:", totalcredits);

    if (totalcredits < 1) {
      console.log("Insufficient credits for video transcode");
      openpayment()
      return
    }

    try {

      notify("", true, t("general.pleasewait"))

      const ffmpeg = ffmpegRef.current;

      await ffmpeg.writeFile('/input.webm', await fetchFile(videourl));
      await ffmpeg.exec(["-i", "/input.webm", "-ss", currenttime, "-vf", "scale=320:320", "-frames:v", "1", "/output_%d.png"])

      const data = await ffmpeg.readFile('/output_1.png');

      var blob = new Blob([data.buffer], { type: 'image/png' })

      let file = new File([blob], "file_name.jpg", { lastModified: 1534584790000 });

      file = await scale(file, {
        // Very small so we can test the outcome
        // maxWidth: 320,
        maxHeight: 200
      });

      ffmpeg.deleteFile('/input.webm')

      const storage = getStorage();
      const randomimagename = (Math.random() + 1).toString(36).substring(7) + ".jpg";
      const imageRef2 = storageRef(storage, loggeduser.userid + `/` + randomimagename)

      const uploadTask = uploadBytesResumable(imageRef2, file)


      uploadTask.on('state_changed',
        (snapshot) => {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          //console.log('Upload is ' + progress + '% done');

          if (progress == 100) {
            closenotify()
          }
          switch (snapshot.state) {
            case 'paused':
              //  console.log('Upload is paused');
              break;
            case 'running':
              break;
          }
        },
        (error) => {
          if (error != undefined) {
            if (error.toString().includes("fetch")) {
              notify("error", false, "error: " + t("sidebar.deniedaccess") + " Video")
            }
            else {
              notify("error", false, "error: " + error.message)

            }
          }

        },
        () => {


          getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {

            parabase64(file).then(async (data) => {
              await addpromptimage(data, downloadURL)

            })


          })
        })
    } catch (error) {
      if (error != undefined) {
        if (error.toString().includes("fetch")) {
          notify("error", false, "error: " + t("sidebar.deniedaccess") + " Video")
        }
        else {
          notify("error", false, "error: " + error.message)

        }
      }

    }
  }

  const transcodeimage = async () => {

    const totalcredits = await getusercreditsprompts()

    if (totalcredits < 1) {
      openpayment()
      return
    }


    if (imageurl === null || imageurl === "") {
      notify("error", false, t("sidebar.pleasetype") + " image")
      return
    }

    try {

      notify("", true, t("general.pleasewait"))
      let url = imageurl
      let blob = await fetch(url).then(r => r.blob());


      const storage = getStorage();
      const randomimagename = (Math.random() + 1).toString(36).substring(7) + ".jpg";
      const imageRef2 = storageRef(storage, loggeduser.userid + `/` + randomimagename)

      let file = new File([blob], "file_name.jpg", { lastModified: 1534584790000 });

      file = await scale(file, {
        // Very small so we can test the outcome
        //maxWidth: 300,
        maxHeight: 200
      });


      const uploadTask = uploadBytesResumable(imageRef2, file)


      uploadTask.on('state_changed',
        (snapshot) => {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          //console.log('Upload is ' + progress + '% done');
          switch (snapshot.state) {
            case 'paused':
              //  console.log('Upload is paused');
              break;
            case 'running':
              //   console.log('Upload is running');
              break;
          }
        },
        (error) => {
          if (error != undefined) {
            if (error.toString().includes("fetch")) {
              notify("error", false, "error: " + t("sidebar.deniedaccess") + " Image")
            }
            else {
              notify("error", false, "error: " + error.message)

            }
          }
        },
        () => {


          getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {

            parabase64(file).then(async (data) => {
              notify("", true, t("general.pleasewait"))
              await addpromptimage(data, downloadURL)
              //console.log("blobr" + data)
              closenotify()
            })


          })
        })
    } catch (error) {
      //alert(error)
      if (error != undefined) {
        if (error.toString().includes("fetch")) {
          notify("error", false, "error: " + t("sidebar.deniedaccess") + " Image")
        }
        else {
          notify("error", false, "error: " + error.message)

        }
      }

    }
  }

  return (
    <>
      <div className="row">
        <Modal
          center
          open={modalPaymentOpen}
          onClose={() => setmodalPaymentOpen(false)}
        //onAfterOpen={afterOpenModal}
        //onRequestClose={closeModal}
        //style={customStyles}
        //contentLabel="Example Modal"
        >
          <div>
            <SectionJobsPayment></SectionJobsPayment>
          </div>
        </Modal>

        <span style={{ paddingTop: "20px", fontWeight: "bold", fontSize: "14px" }}>
          <BsJournalRichtext color="white" size="15" />
          {t("sidebar.generateprompts")}</span>


        <div style={{ alignContent: "center", textAlign: "center" }}>
          <ul className="nav nav-tabs" id="myTab3" role="tablist">
            <li className="nav-item" role="presentation">
              <button onClick={(e) => { setprivatepromp(false) }} className="nav-link active" id="Monthly" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab">{t("sidebar.fromimage")}</button>
            </li>
            <li className="nav-item" role="presentation">
              <button onClick={(e) => { setprivatepromp(false) }} className="nav-link" id="annual" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile">{t("sidebar.fromvideo")}</button>
            </li>
            <li className="nav-item" role="presentation">
              <button onClick={(e) => { setprivatepromp(false) }} className="nav-link" id="annual" data-bs-toggle="tab" data-bs-target="#profile2" type="button" role="tab" aria-controls="profile">{t("sidebar.fromtext")}</button>
            </li>
          </ul>
          <div className="tab-content" id="myTab3Content">
            <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="Monthly">
              <span className="woocommerce-result-count">
                <div style={{ width: "100%" }} className="masonry-wrap row d-flex">
                  {/*prompt image*/}
                  <div className="masonry-item col-md-12">
                    <div className="blog-post twm-blog-post-1-outer">
                      <div className="wt-post-info">
                        <div className="wt-post-meta ">
                          <ul>
                            <li className="post-date">
                              <BsJournalRichtext color="white" size="15" />
                              {t("sidebar.generatefromimagedesc")}</li>
                          </ul>
                        </div>
                        <div className="wt-post-title ">
                          <form>
                            <div className="form-group mb-4">
                              <h4 className="section-head-small mb-4">{t("sidebar.typeimagelink")}</h4>
                              <div>
                                <input type="text" onChange={(e) => { e.preventDefault(); changeimagetext(e) }} className="form-control" placeholder={imageurl.includes("blob") ? "" : imageurl} />

                                <div >-------{t("sidebar.or")}-------</div>

                                {/*Logo and Cover image*/}
                                <div className="upload-btn-wrapper">
                                  <button className="site-button button-sm">
                                    <LuUpload color="white" size="15"></LuUpload>
                                    {t("sidebar.uploadphoto")}</button>
                                  <input type="file" name="myfile" id="file-uploader" accept=".jpg, .jpeg, .png" />

                                </div>
                                <div style={{ padding: "10px" }}>
                                  <LazyLoadImage src={imageurl} id="upload-image-grid" style={{ width: "100%" }} />
                                </div>

                                <div style={{ paddingBottom: "20px", paddingTop: "20px", width: "100%", alignItems: "center", textAlign: 'center', alignContent: "center", justifyContent: "center" }}>


                                  <div style={{ width: "70%" }} className="form-control">
                                    <div className="form-check form-switch">
                                      <input onChange={(event) => { setchecked(event.target.checked, "image") }} className="form-check-input" type="checkbox" role="switch" id="CheckCheckedImage"></input>
                                      <label className="form-check-label">{t('sidebar.privatemode')}</label>
                                    </div>
                                  </div>
                                </div>


                                <div className="form-submit">
                                  {imageurl.includes("jpg") || imageurl.includes("jpeg") || imageurl.includes("png") || imageurl.includes("blob") ?
                                    <button type="submit" className="site-button" onClick={(e) => { e.preventDefault(); transcodeimage() }}>

                                      <BsJournalRichtext color="white" size="15" />
                                      {t("sidebar.generateprompt")}</button>
                                    :
                                    <button disabled type="submit" className="site-button">
                                      <BsJournalRichtext color="white" size="15" />
                                      {t("sidebar.generateprompt")}</button>
                                  }
                                </div>



                              </div>
                            </div>
                          </form>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>

              </span>
            </div>

            <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="annual">
              {/* from video */}
              <div style={{ width: "100%" }} className="masonry-wrap row d-flex">
                <div className="masonry-item col-md-12">
                  <div className="blog-post twm-blog-post-1-outer">
                    <div className="wt-post-info">
                      <div className="wt-post-meta ">
                        <ul>
                          <li className="post-date">
                            <BsJournalRichtext color="white" size="15" />
                            {t("sidebar.generatefromvideodesc")}</li>
                        </ul>
                      </div>
                      <div className="wt-post-title ">
                        <form>
                          <div className="form-group mb-4">
                            <h4 className="section-head-small mb-4">{t("sidebar.typevideolink")}</h4>
                            <div className="input-group">
                              <input onChange={(e) => { e.preventDefault(); changevideotext(e) }} type="text" className="form-control" placeholder="https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4" />
                            </div>

                            <div >-------{t("sidebar.or")}-------</div>


                            {/*Logo and Cover image*/}
                            <div className="upload-btn-wrapper">
                              <button className="site-button button-sm">
                                <LuUpload color="white" size="15"></LuUpload>
                                {t("sidebar.uploadvideo")}</button>
                              <input type="file" name="myfile" id="file-uploaderv" accept=".mp4, .avi, .wmv" />
                            </div>

                            <div style={{ padding: "10px" }}>
                              <video id="video-grid" width="100%" src={videourl} controls
                                ref={ref}
                                onPause={e => handlePause(e)}
                                // onReady={e => handleReady(e)} 
                                // onPlay={handlePlay}
                                onSeeking={e => handleSeekChange(e)}
                              // onProgress={handleProgress}
                              />
                              <div><span style={{ fontSize: '8px', fontWeight: "bold" }}>Seek or Pause video in one frame</span></div>


                              <div style={{ paddingBottom: "20px", paddingTop: "20px", width: "100%", alignItems: "center", textAlign: 'center', alignContent: "center", justifyContent: "center" }}>
                                <div style={{ width: "70%" }} className="form-control">
                                  <div className="form-check form-switch">
                                    <input onChange={(event) => { setchecked(event.target.checked, "video") }} className="form-check-input" type="checkbox" role="switch" id="CheckCheckedVideo"></input>
                                    <label className="form-check-label">{t('sidebar.privatemode')}</label>
                                  </div>
                                </div>
                              </div>

                              {/* <img style={{padding:'10px'}} width="50%" src={imageRef} ref={imageRef}></img><br /> */}

                              {currenttime === "00:00:00" && !videourl.includes("mp4") && !videourl.includes("avi") && !videourl.includes("wmv") && !videourl.includes("blob") ?
                                <button disabled type="submit" className="site-button" onClick={(e) => { e.preventDefault(); transcodevideo() }}>
                                  <BsJournalRichtext color="white" size="15" />
                                  {t("sidebar.generateprompt")}</button>
                                :
                                <button type="submit" className="site-button" onClick={(e) => { e.preventDefault(); transcodevideo() }}>
                                  <BsJournalRichtext color="white" size="15" />
                                  {t("sidebar.generateprompt")}</button>
                              }
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div className="tab-pane fade" id="profile2" role="tabpanel" aria-labelledby="annual">
              {/* from text */}
              <span className="woocommerce-result-count">
                <div style={{ width: "100%" }} className="masonry-wrap row d-flex">                  {/*Block one*/}
                  <div className="masonry-item col-md-12">
                    <div className="blog-post twm-blog-post-1-outer">
                      <div className="wt-post-info">
                        <div className="wt-post-meta ">
                          <ul>
                            <li className="post-date">
                              <BsJournalRichtext color="white" size="15" />
                              {t("sidebar.generatefromtextdesc")}</li>
                          </ul>
                        </div>
                        <div className="wt-post-title ">
                          <form>

                            <div className="form-group mb-4">
                              <div>
                                <h4 className="section-head-small mb-4">{t("sidebar.typetext")}</h4>
                              </div>

                              <div style={{ padding: "10px" }}>
                                <input onChange={(e) => { e.preventDefault(); changetxttext(e) }} type="text" className="form-control" placeholder={t("sidebar.typetextplaceholder")} />




                                <div style={{ paddingBottom: "20px", paddingTop: "20px", width: "100%", alignItems: "center", textAlign: 'center', alignContent: "center", justifyContent: "center" }}>
                                  <div style={{ width: "70%" }} className="form-control">
                                    <div className="form-check form-switch">
                                      <input onChange={(event) => { setchecked(event.target.checked, "text") }} className="form-check-input" type="checkbox" role="switch" id="CheckCheckedText"></input>
                                      <label className="form-check-label">{t('sidebar.privatemode')}</label>
                                    </div>
                                  </div>
                                </div>

                              </div>
                              <div className="form-submit">
                                <button type="submit" className="site-button" onClick={(e) => { e.preventDefault(); addprompttext() }}>
                                  <BsJournalRichtext color="white" size="15" />
                                  Generate Prompt</button>
                              </div>

                            </div>
                          </form>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

              </span>

            </div>



          </div>
        </div>
      </div>

    </>
  )
}

export default SectionJobsSidebar1;